import { render, staticRenderFns } from "./WFAdd.vue?vue&type=template&id=18dc4e44"
import script from "./WFAdd.vue?vue&type=script&lang=js"
export * from "./WFAdd.vue?vue&type=script&lang=js"
import style0 from "./WFAdd.vue?vue&type=style&index=0&id=18dc4e44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports